import React from 'react';
import { GridContainer, LeftSideBar, CenterContent, RightSideBar } from 'global/components/perform-grid';
import Filters from './filters';
import Table from './table';
import { useScreen } from 'global/styles';
import VendorHeader from './vendor-header';
import { useClients } from 'global/hooks/useVendors';

export default (props) => {
  const { isMobile } = useScreen();
  const vendors = useClients();

  return (
    <GridContainer>
      <LeftSideBar hidden={isMobile}>
        <Filters vendors={vendors} />
      </LeftSideBar>

      <CenterContent>
        {isMobile && <Filters vendors={vendors} />}
        <VendorHeader vendors={vendors} />
        <Table allowedPermissions={['manageUsers']} vendors={vendors} />
      </CenterContent>

      <RightSideBar />
    </GridContainer>
  );
};
